<template>
  <div>
    <!-- 渲染html -->
    <div :class="wrapClass">
      <!-- 截取content生成图片 -->
      <div ref="mybox" crossOrigin="Anonymous">
        <div class="wrapnav">
          <div class="day-container">
            <div class="position-fixed" id="content">
              <!-- 背景图 -->
              <div class="mouth-bg"></div>
              <!-- 保存图标 -->
              <div class="saveImg" @click="longpress" v-if="longpressShow">
                <img src="../assets/report/save_icon.png" alt="保存" />
              </div>
              <div class="top_time">
                <span class="studyTitle">本月学习</span>
                <div class="studytime">{{ timeShow }}</div>
              </div>
              <div class="dayCard">
                <div class="top-preview">
                  <div class="realTop">
                    <div class="realTop-imgbox">
                      <img :src="userInfo.avatar" class="realTop-img" />
                    </div>

                    <div class="realInfo">
                      <span class="realInfo-name">{{ userInfo.name||"姓名" }}</span>
                      <span class="realInfo-grade">{{
                        userInfo.gradeStr
                      }}</span>
                    </div>
                  </div>
                </div>
                <!-- 栅栏布局 -->
                <van-row
                  type="flex"
                  justify="space-between"
                  class="top-nav marLR10 marginB10"
                >
                  <van-col span="12" @click="showTipModal=true" >
                    <div class="font-12 marginB10">本月总学习时长</div>
                    <div class="mainColor">
                      <span class="font-24 bold">{{
                        effectiveTimes_hour ? effectiveTimes_hour : "0"
                      }}</span
                      ><span class="font-15 bold">小时</span>
                      <span class="font-24 bold">{{
                        effectiveTimes_min ? effectiveTimes_min : "0"
                      }}</span
                      ><span class="font-15 bold">分钟</span>
                    </div>
                  </van-col>
                </van-row>
              </div>
              <div class="detailCard">
                <!-- 栅栏布局 -->
                <div class="detailCard-title flex_center">
                  <img
                    src="../assets/report/tip5.png"
                    alt="背景"
                    class="detailCard-title-img"
                  />
                </div>
                <div class="detailBox">
                  <div class="detailBox-cn">
                    <div class="detailBox-top">
                      <div class="detailBox-top-nav">
                        <span class="top-title">中文记忆</span>
                      </div>
                    </div>
                    <div class="detailBox-nav">
                      <div class="detailBox-nav-card">
                        <span class="nav-card-title">本月学习时长</span>
                        <span class="nav-card-desc"
                          ><em class="colorTip font-18 bold">{{
                            detaTime.chStudyTime&&detaTime.chStudyTime.hour || 0
                          }}</em
                          >小时<em class="colorTip font-18 bold">{{
                            detaTime.chStudyTime&&detaTime.chStudyTime.min || 0
                          }}</em
                          >分钟</span
                        >
                      </div>
                      <div class="detailBox-nav-card">
                        <span class="nav-card-title">本月掌握古诗</span>
                        <span class="nav-card-desc"
                          ><em class="colorTip font-18 bold">{{
                            detailInfo.chNewLearnPoetry
                              ? detailInfo.chNewLearnPoetry
                              : 0
                          }}</em
                          >首</span
                        >
                      </div>
                      <div class="detailBox-nav-card">
                        <span class="nav-card-title">本月复习古诗</span>
                        <span class="nav-card-desc"
                          ><em class="colorTip font-18 bold">{{
                            detailInfo.chReviewPoetry
                              ? detailInfo.chReviewPoetry
                              : 0
                          }}</em
                          >首</span
                        >
                      </div>
                      <div class="detailBox-nav-card">
                        <span class="nav-card-title">本月掌握要点</span>
                        <span class="nav-card-desc"
                          ><em class="colorTip font-18 bold">{{
                            detailInfo.chNewLearnPoint
                              ? detailInfo.chNewLearnPoint
                              : 0
                          }}</em
                          >个</span
                        >
                      </div>
                      <div class="detailBox-nav-card">
                        <span class="nav-card-title">本月复习要点</span>
                        <span class="nav-card-desc"
                          ><em class="colorTip font-18 bold">{{
                            detailInfo.chReviewPoint
                              ? detailInfo.chReviewPoint
                              : 0
                          }}</em
                          >个</span
                        >
                      </div>
                      <!-- 弹性布局占位单位 -->
                      <div style="width: 31%" />
                    </div>
                  </div>
                  <div class="detailBox-en">
                    <div class="detailBox-top">
                      <div class="detailBox-top-nav">
                        <span class="top-title">英文记忆</span>
                      </div>
                    </div>
                    <div class="detailBox-nav">
                      <div class="detailBox-nav-card">
                        <span class="nav-card-title">本月学习时长</span>
                        <span class="nav-card-desc"
                          ><em class="colorTip font-18 bold">{{
                         detaTime.enStudyTime&&detaTime.enStudyTime.hour || 0
                          }}</em
                          >小时<em class="colorTip font-18 bold">{{
                             detaTime.enStudyTime&&detaTime.enStudyTime.min || 0
                          }}</em
                          >分钟</span
                        >
                      </div>
                      <div class="detailBox-nav-card">
                        <span class="nav-card-title">本月掌握单词</span>
                        <span class="nav-card-desc"
                          ><em class="colorTip font-18 bold">{{
                            detailInfo.enNewLearnWord
                              ? detailInfo.enNewLearnWord
                              : 0
                          }}</em
                          >个</span
                        >
                      </div>
                      <div class="detailBox-nav-card">
                        <span class="nav-card-title">本月复习单词</span>
                        <span class="nav-card-desc"
                          ><em class="colorTip font-18 bold">{{
                            detailInfo.enReviewWord
                              ? detailInfo.enReviewWord
                              : 0
                          }}</em
                          >个</span
                        >
                      </div>
                      <div class="detailBox-nav-card">
                        <span class="nav-card-title">本月朗读单词</span>
                        <span class="nav-card-desc"
                          ><em class="colorTip font-18 bold">{{
                            detailInfo.enReadWord ? detailInfo.enReadWord : 0
                          }}</em
                          >个</span
                        >
                      </div>
                      <!-- 弹性布局占位单位 -->
                      <div style="width: 31%" />
                    </div>
                  </div>
                <!-- 历史 -->
                <div class="detailBox-hs">
                    <div class="detailBox-top">
                      <div class="detailBox-top-nav">
                        <span class="top-title"> 历史记忆</span>
                      </div>
                    </div>
                    <div class="detailBox-nav">
                      <div class="detailBox-nav-card">
                        <span class="nav-card-title">本月学习时长</span>
                        <span class="nav-card-desc"
                          ><em class="colorTip font-18 bold">{{
                            detaTime.historyStudyTime&&detaTime.historyStudyTime.hour || 0
                          }}</em
                          >小时<em class="colorTip font-18 bold">{{
                            detaTime.historyStudyTime&&detaTime.historyStudyTime.min || 0
                          }}</em
                          >分钟</span
                        >
                      </div>
                      <div class="detailBox-nav-card">
                        <span class="nav-card-title">本月掌握知识点</span>
                        <span class="nav-card-desc"
                          ><em class="colorTip font-18 bold">{{
                            detailInfo.historyLearnPoint
                              ? detailInfo.historyLearnPoint
                              : 0
                          }}</em
                          >个</span
                        >
                      </div>
                      <!-- 弹性布局占位单位 -->
                      <div style="width: 31%" />
                    </div>
                  </div>
                  <!--  地理-->
                  <div class="detailBox-dl">
                    <div class="detailBox-top">
                      <div class="detailBox-top-nav">
                        <span class="top-title"> 地理记忆</span>
                      </div>
                    </div>
                    <div class="detailBox-nav">
                      <div class="detailBox-nav-card">
                        <span class="nav-card-title">本月学习时长</span>
                        <span class="nav-card-desc"
                          ><em class="colorTip font-18 bold">{{
                            detaTime.geographyStudyTime&&detaTime.geographyStudyTime.hour || 0
                          }}</em
                          >小时<em class="colorTip font-18 bold">{{
                            detaTime.geographyStudyTime&&detaTime.geographyStudyTime.min || 0
                          }}</em
                          >分钟</span
                        >
                      </div>
                      <div class="detailBox-nav-card">
                        <span class="nav-card-title">本月掌握知识点</span>
                        <span class="nav-card-desc"
                          ><em class="colorTip font-18 bold">{{
                            detailInfo.geographyLearnPoint
                              ? detailInfo.geographyLearnPoint
                              : 0
                          }}</em
                          >个</span
                        >
                      </div>
                      <!-- 弹性布局占位单位 -->
                      <div style="width: 31%" />
                    </div>
                  </div>
                  <!--  生物-->
                  <div class="detailBox-sw">
                    <div class="detailBox-top">
                      <div class="detailBox-top-nav">
                        <span class="top-title"> 生物记忆</span>
                      </div>
                    </div>
                    <div class="detailBox-nav">
                      <div class="detailBox-nav-card">
                        <span class="nav-card-title">本月学习时长</span>
                        <span class="nav-card-desc"
                          ><em class="colorTip font-18 bold">{{
                           detaTime.biologyStudyTime&& detaTime.biologyStudyTime.hour || 0
                          }}</em
                          >小时<em class="colorTip font-18 bold">{{
                           detaTime.biologyStudyTime&& detaTime.biologyStudyTime.min || 0
                          }}</em
                          >分钟</span
                        >
                      </div>
                      <div class="detailBox-nav-card">
                        <span class="nav-card-title">本月掌握知识点</span>
                        <span class="nav-card-desc"
                          ><em class="colorTip font-18 bold">{{
                            detailInfo.biologyLearnPoint
                              ? detailInfo.biologyLearnPoint
                              : 0
                          }}</em
                          >个</span
                        >
                      </div>

                      <!-- 弹性布局占位单位 -->
                      <div style="width: 31%" />
                    </div>
                  </div>
                </div>
              </div>
          

              <img
                src="../assets/report/logo.png"
                alt="logo"
                class="bottom-logo"
              />
            </div>
          </div>
        </div>
      </div>
      <!-- 长按操作 -->
      <van-popup
        v-model="settingShow"
        position="bottom"
        :class="popupClass"
        :style="{ boxShadow: '0px -2px 6px ' + bgColor }"
        :lock-scroll="false"
        overlay-class="popup-mask"
      >
        <div class="set-bar">
          <van-share-sheet
            v-model="showShare"
            title="立即分享给好友"
            :options="options"
            @select="onSelect"
          />
        </div>
      </van-popup>
    </div>

    <!-- 海报 -->
    <div v-if="maskHidden">
      <div class="imagePathBox">
        <div
          class="shengcheng-v"
          style="width: 405px; height: 100%; position: fixed; top: 3%"
        >
          <div class="icon-cancel">
            <van-icon name="close" @click="closeMask" />
          </div>
          <img :src="imagePath" class="shengcheng" crossOrigin="Anonymous" />
          <div class="flex_space">
            <button class="save" @click="save">长按上方图片保存</button>
            <!-- <button open-type="share" class='save '>微信分享</button> -->
          </div>
        </div>
      </div>
      <div class="mask"></div>
    </div>
    <!-- 海报结束 -->

    <!--提示弹窗-->
    <div class="tip-fixed-box" v-if="showTipModal">
      <div class="model-hideBox" @click="hidetipModal">
        <span class="model-hide">
          <van-icon name="cross" size="20" />
        </span>
      </div>
      <div class="modal_flex">
        <div class="modal-content">
          <span class="modal-text"
            >*本月总学习时长:【中文记忆】、【英文记忆】、【历史记忆】、【地理记忆】和【生物大师】本月总学习时长的总和</span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
import html2canvas from "html2canvas";
import Toast from "vant/lib/toast";
import Icon from "vant/lib/icon";
import Dialog from "vant/lib/dialog";
import Search from "vant/lib/search";
import List from "vant/lib/list";
import Button from "vant/lib/button";
import Cell from "vant/lib/cell";
import Popup from "vant/lib/popup";
import Row from "vant/lib/row";
import Col from "vant/lib/col";
import ShareSheet from "vant/lib/share-sheet";

import "vant/lib/toast/style";
import "vant/lib/icon/style";
import "vant/lib/dialog/style";
import "vant/lib/search/style";
import "vant/lib/list/style";
import "vant/lib/button/style";
import "vant/lib/cell/style";
import "vant/lib/popup/style";
import "vant/lib/row/style";
import "vant/lib/col/style";
import "vant/lib/share-sheet/style";
export default {
  components: {
    "van-toast": Toast,
    "van-popup": Popup,
    "van-icon": Icon,
    "van-dialog": Dialog,
    "van-search": Search,
    "van-list": List,
    "van-cell": Cell,
    "van-row": Row,
    "van-col": Col,
    "van-button": Button,
    "van-share-sheet": ShareSheet,
  },
  data() {
    return {
      timeShow: "", //展示时间
      userInfo: {}, //头部基本信息
      detailInfo: {}, //学习详情
      detaTime: {}, //学习时间
      effectiveTimes:0,//有效学习总时长
      effectiveTimes_hour: 0, //有效学习小时
      effectiveTimes_min: 0, //有效学习分钟
      settingShow: false,
      bgColor: "white", // coral  palegreen  black
      popupClass: { "van-popup": true, "bg-white": true },
      wrapClass: { wrap: true, "bg-white": true },
      loading: false,
      parentId: "", //家长id 家长只能绑定两个账号
      studentId: "", //学生id
      showShare: false, //分享框隐藏
      options: [{ name: "分享海报", icon: "poster" }],
      maskHidden: false, //黑色遮罩层
      flag: false, //显示二维码
      imagePath: "", //海报图片
      canvasHeight: 500, //canvas画布高度,
      qrcodePath: "", //二维码图片
      showModal: true,
      longpressShow: true, //是否展示保存图片按钮
      showTipModal: false, //提示弹窗
      snNo:'',
      dataType:'',
      reportTime: "",
    };
  },
  watch: {},
  //路由守卫
  beforeRouteEnter(to, from, next) {
    // ios微信分享需要重新设置URL
    next((vm) => {
      if (!window.sessionStorage.getItem("shareURLReset")) {
        window.sessionStorage.setItem("shareURLReset", window.location.href);
        window.location.href = window.location.href;
      }
    });
  },
  created() {
    return false
    // 对浏览器的UserAgent进行正则匹配，不含有微信独有标识的则为其他浏览器
    let ua = navigator.userAgent.toLowerCase();
    let isWeixin = ua.indexOf("micromessenger") != -1;
    if (!isWeixin) {
      this.longpressShow = false;
      // window.location.href =
      //   "https://open.weixin.qq.com/connect/oauth2/authorize?appid=888";
    }
    let herf = window.location.href.split("&from")[0];
    let that = this;
    let parentId = that.$route.query.parentId;
    const options = {
      method: "GET",
      url: this.$api.getJsapiTicket + "?url=" + encodeURIComponent(herf),
    };
    this.$http(options).then((res) => {
      if (res.data.code === 200) {
        let url = res.data.data.url; //后台返回的url
        let wxTitle = "忆学-本月学习"; // 分享标题
        let wxDesc = "查看忆学-本月学习吧"; // 分享描述
        let wxImgUrl =
          "http://cdn.yixuewang.cn/yxwx/picture/171b3c8cb2334048806f6e1cc0a97bc2.png"; // 分享图标
        let wxShareUrl = url; //取后台返回的参数
        wx.config({
          // debug: true, // 开启调试模式,
          appId: res.data.data.appId, // 必填，企业号的唯一标识，此处填写企业号corpid
          timestamp: res.data.data.timestamp, // 必填，生成签名的时间戳
          nonceStr: res.data.data.nonceStr, // 必填，生成签名的随机串
          signature: res.data.data.signature, // 必填，签名，见附录1
          jsApiList: [
            "updateAppMessageShareData",
            "updateTimelineShareData",
            "onMenuShareAppMessage",
            "onMenuShareTimeline",
          ], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        });
        // wx.checkJsApi({
        //   jsApiList: [
        //     "updateAppMessageShareData",
        //     "updateTimelineShareData",
        //     "onMenuShareAppMessage", //老版本分享接口。
        //     "onMenuShareTimeline" //老版本分享接口。
        //   ], // 需要检测的JS接口列表，所有JS接口列表见附录2,
        //   success: function(res) {
        //     // 以键值对的形式返回，可用的api值true，不可用为false
        //     // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
        //   },
        //   error: function(res) {
        //     alert("checkJsApi分享异常");
        //   }
        // });
        wx.ready(function () {
          wx.checkJsApi({
            // 检验接口是否有效
            jsApiList: [
              "updateAppMessageShareData",
              "updateTimelineShareData",
              "onMenuShareAppMessage",
              "onMenuShareTimeline",
            ],
            success(res) {
              if (res.checkResult.getLocation == false) {
                alert(
                  "你的微信版本太低，不支持微信JS接口，请升级到最新的微信版本！"
                );
                return;
              }
            },
            cancel(res) {},
          });
          // var shareData = {
          //   title: wxTitle, // 分享标题
          //   link: wxShareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          //   imgUrl: wxImgUrl, // 分享图标
          //   desc: wxDesc,
          //   success: function() {
          //     // 用户点击了分享后执行的回调函数
          //     setTimeout(function() {
          //       that.doShareDone(parentId);
          //       //回调要执行的代码
          //     }, 500);
          //   },
          //   error: function(res) {
          //     console.log("分享异常", res);
          //   }
          // };
          // 分享给好友
          wx.onMenuShareAppMessage({
            title: wxTitle, // 分享标题
            desc: wxDesc, // 分享描述
            link: wxShareUrl, // 分享链接
            imgUrl: wxImgUrl, // 分享图标
            success: function () {
              setTimeout(function () {
                that.doShareDone(parentId);
                //回调要执行的代码
              }, 500);
            },
            cancel: function () {
              that.doShareCancel();
            },
          });
          // 分享到朋友圈
          wx.onMenuShareTimeline({
            title: wxTitle, // 分享标题
            desc: wxDesc, // 分享描述
            link: wxShareUrl, // 分享链接
            imgUrl: wxImgUrl, // 分享图标
            success: function () {
              setTimeout(function () {
                that.doShareDone(parentId);
                //回调要执行的代码
              }, 500);
            },
            cancel: function () {
              that.doShareCancel();
            },
          });
        });
        wx.error(function (res) {
          console.log("wx.error", res);
          // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
        });
      } else {
        console.log("请求jssdk接口失败", res.data.msg);
        // Toast("请求jssdk接口失败", res.data.msg);
      }
    });
  },
  mounted() {
    this.parentId = this.$route.query.parentId; //地址栏获取家长id
    this.dataType = this.$route.query.dataType
      ? this.$route.query.dataType
      : ""; //地址栏获取时间类型
    this.reportTime = this.$route.query.date ? this.$route.query.date : ""; //地址栏获取时间
    this.snNo = this.$route.query.snNo ? this.$route.query.snNo : ""; //地址栏获取sn号
    this.loadData(); //获取页面基本数据
    let timeShow=this.reportTime.split('-')
    this.timeShow=timeShow[0]+'年'+timeShow[1]+'月'
  },
  methods: {
    hidetipModal() {
      this.showTipModal = false;
    },
    hideModal() {
      this.showModal = false;
    },
    // 分享成功回调
    doShareDone(val) {
      let parentId = val;
      let that = this;
      const options = {
        method: "GET",
        url:
          that.$api.shareToWechat +
          "?parentId=" +
          parentId +
          "&studentId=" +
          that.studentId,
      };
      that.$http(options).then((res) => {
        if (res.data.code === 200) {
          Dialog.alert({
            message: res.data.msg,
          }).then(() => {});
        } else {
          Dialog.alert({
            message: "服务器开小差了，请稍后再试",
          }).then(() => {
            // on close
          });
        }
      });
    },
    //分享初始化
    next() {
      let that = this;
      let parentId = that.$route.query.parentId;
      const options = {
        method: "GET",
        url:
          this.$api.getJsapiTicket +
          "?url=" +
          encodeURIComponent(window.location.href),
      };
      this.$http(options).then((res) => {
        if (res.data.code === 200) {
          let url = res.data.data.url; //后台返回的url
          let wxTitle = "忆学-本月学习"; // 分享标题
          let wxDesc = "查看忆学-本月学习吧"; // 分享描述
          let wxImgUrl =
            "http://cdn.yixuewang.cn/yxwx/picture/171b3c8cb2334048806f6e1cc0a97bc2.png"; // 分享图标
          let wxShareUrl = url; // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          wx.config({
            // debug: true, // 开启调试模式,
            appId: res.data.data.appId, // 必填，企业号的唯一标识，此处填写企业号corpid
            timestamp: res.data.data.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.data.data.nonceStr, // 必填，生成签名的随机串
            signature: res.data.data.signature, // 必填，签名，见附录1
            jsApiList: [
              "onMenuShareAppMessage",
              "onMenuShareTimeline",
              "updateAppMessageShareData",
              "updateTimelineShareData",
            ], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
          });

          wx.ready(function () {
            wx.checkJsApi({
              // 检验接口是否有效
              jsApiList: [
                "onMenuShareAppMessage",
                "onMenuShareTimeline",
                "updateAppMessageShareData",
                "updateTimelineShareData",
              ],
              success(res) {
                if (res.checkResult.getLocation == false) {
                  alert(
                    "你的微信版本太低，不支持微信JS接口，请升级到最新的微信版本！"
                  );
                  return;
                }
              },
              cancel(res) {},
            });
            // 分享给好友
            wx.updateAppMessageShareData({
              title: wxTitle, // 分享标题
              desc: wxDesc, // 分享描述
              link: wxShareUrl, // 分享链接
              imgUrl: wxImgUrl, // 分享图标
              success: function () {
                setTimeout(function () {
                  that.doShareDone(parentId);
                  //回调要执行的代码
                }, 500);
              },
              cancel: function () {
                that.doShareCancel();
              },
            });
            // 分享到朋友圈
            wx.updateTimelineShareData({
              title: wxTitle, // 分享标题
              desc: wxDesc, // 分享描述
              link: wxShareUrl, // 分享链接
              imgUrl: wxImgUrl, // 分享图标
              success: function () {
                setTimeout(function () {
                  that.doShareDone(parentId);
                  //回调要执行的代码
                }, 500);
              },
              cancel: function () {
                that.doShareCancel();
              },
            });
            // 分享给好友
            wx.onMenuShareAppMessage({
              title: wxTitle, // 分享标题
              desc: wxDesc, // 分享描述
              link: wxShareUrl, // 分享链接
              imgUrl: wxImgUrl, // 分享图标
              success: function () {
                setTimeout(function () {
                  that.doShareDone(parentId);
                  //回调要执行的代码
                }, 500);
              },
              cancel: function () {
                that.doShareCancel();
              },
            });
            // 分享到朋友圈
            wx.onMenuShareTimeline({
              title: wxTitle, // 分享标题
              desc: wxDesc, // 分享描述
              link: wxShareUrl, // 分享链接
              imgUrl: wxImgUrl, // 分享图标
              success: function () {
                setTimeout(function () {
                  that.doShareDone(parentId);
                  //回调要执行的代码
                }, 500);
              },
              cancel: function () {
                that.doShareCancel();
              },
            });
          });
          wx.error(function (res) {
            // console.log("wx.error",res)
            // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
          });
        } else {
        }
      });
    },
    //关闭弹框
    closeMask() {
      this.maskHidden = false;
      this.imagePath = ""; //海报图片清空
      //重置画布
      const canvas = document.createElement("canvas");
      var cxt = canvas.getContext("2d");
      canvas.height = canvas.height;
    },
    //点击分享内容时触发
    onSelect(option) {
      // Toast(option.name);
      this.showShare = false;
    },
    //点击保存到相册
    save: function () {
      let that = this;
      this.maskHidden = false;
      this.imagePath = ""; //海报图片清空
      // this.downloadImage(this.imagePath); //下载图片到本地
    },

    // 生成图片
    productionImage() {
      // 页面下滑画布缺少一半  解决办法：在生成图片之前 让滚动条高度为0就好
      window.pageYOffset = 0;
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      // 手动创建一个 canvas 标签
      const canvas = document.createElement("canvas");
      // 获取父标签，意思是这个标签内的 DOM 元素生成图片
      let canvasBox = document.getElementById("content");
      canvasBox.crossOrigin = "Anonymous";
      // 获取父级的宽高
      const width = parseInt(window.getComputedStyle(canvasBox).width);
      const height = parseInt(window.getComputedStyle(canvasBox).height);
      const scale = 2; //定义任意放大倍数 支持小数
      // 宽高 * 6 并放大 6 倍 是为了防止图片模糊
      canvas.width = width * 2;
      canvas.height = height * 2;
      canvas.style.width = width + "px";
      canvas.style.height = height + "px";
      const context = canvas.getContext("2d");

      const options = {
        backgroundColor: null,
        canvas: canvas,
        useCORS: true, //【重要】开启跨域配置
        logging: false, //日志开关，便于查看html2canvas的内部执行流程
        scroll: 0,
        scale: scale,
      };
      this.$nextTick(() => {
        setTimeout(() => {
          html2canvas(canvasBox, options).then((canvas) => {
            this.maskHidden = true; //遮罩层和海报显示
            let dataURL = canvas.toDataURL("image/png");
            this.imagePath = dataURL; //海报图片
          });
        }, 500);
      });
    },

    // 取消分享回调
    doShareCancel() {
      // this.qrcodeHidden = false;  //二维码出来
    },
    //初始化请求
    loadData() {
      let params = {
        dataType: this.dataType,
        date: this.reportTime,
        snNo: this.snNo
      };
      const options = {
        method: "POST",
        url: this.$api.getDay,
        data: params
      };
      this.$http(options)
        .then(res => {
          if (res.data.code === 200) {
            this.loading = false;
            let data = res.data.data;
            this.detailInfo = data; //学习信息
            // 学习时间
            let biologyStudyTime = this.timeConversion(
              data.biologyStudyTime || 0
            ); //生物
            let chStudyTime = this.timeConversion(data.chStudyTime || 0); //语文
            let enStudyTime = this.timeConversion(data.enStudyTime || 0); //英语
            let geographyStudyTime = this.timeConversion(
              data.geographyStudyTime || 0
            ); //地理
            let historyStudyTime = this.timeConversion(
              data.historyStudyTime || 0
            ); //历史
            this.detaTime = {
              biologyStudyTime,
              chStudyTime,
              enStudyTime,
              geographyStudyTime,
              historyStudyTime
            };
            //有效学习时长(分钟)
            let min = this.effectiveTimes; //分钟
            let hour = parseInt(min / 60); // 得到小时
            min = min - hour * 60;
            this.effectiveTimes_min = min;
            this.effectiveTimes_hour = hour;
          } else {
            this.loading = true;
            Dialog({
              message: res.data.msg,
              showConfirmButton: false,
              showCancelButton: false
            });
          }
        })
        .catch(res => {
          this.loading = true;
        });
    },
     //时间转换
     timeConversion(num) {
      let totalMin = parseInt(num / 60) || 0; // 得到总分钟
      let hour = parseInt(totalMin / 60); // 得到小时
      let min = totalMin - hour * 60;
      this.effectiveTimes += totalMin;
      return { hour, min };
    },
   
    longpress() {
      // Toast("长按");
      let that = this;
      // if (that.qrcodePath != "") {
      //如果海报地址不为空
      that.flag = true; //二维码出来
      setTimeout(function () {
        that.productionImage(); //生成图片方法
      }, 500);
      // }
    },
    clickWrap() {
      this.settingShow = false; //设置分享隐藏
      this.showShare = false; //隐藏分享按钮
    },
  },
};
</script>

<style scoped>
@import "../assets/iconfont/font_set_read_bar/iconfont.css";
@import "../styles/common.css";
@import "../styles/style.css";
@import "../styles/report.css";
/* 阻止文本复制 */
* {
  /* -moz-user-select: none; */
  -o-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
  /*  默认长按链接与图片弹出菜单 */
  -webkit-touch-callout: default;
}
.position-fixed {
  background: linear-gradient(175deg, #976afb 0%, #e68bea 86%);
}
.colorTip {
  color: #f98e3f;
}
.colorTipDuan {
  color: #f98e3f;
  font-size: 0.8em;
  font-weight: bold;
}
.trailCard-title {
  position: relative;
  width: 100%;
  height: 40px;
}
.trailCard-title-img {
  position: absolute;
  top: -11px;
  width: 140px;
  height: 100%;
}

.position-canvas {
  width: 100%;
  position: absolute;
  left: 0;
  top: -30px;
}
.canvas-tip {
  width: 80%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.smallBox {
  width: 13px;
  height: 13px;
  background: #febb01;
  border-radius: 3px;
  margin-right: 20px;
}

.detailCard {
  position: relative;
  min-height: 30px;
  margin: 10px 17px;
  /* padding-bottom: 16px; */
  background-color: #ffffff;
  border-radius: 20px;
  height: 23.5%;
  /* box-shadow: 0px 0px 17px 1px #5983ff; */
  padding: 12px;
}
.detailCard-title {
  position: relative;
  width: 100%;
  height: 40px;
}
.detailCard-title-img {
  position: absolute;
  top: -22px;
  width: 176px;
  height: 100%;
}
.detailBox {
  display: flex;
  flex-direction: column;
  margin-bottom: 15px;
}
.detailBox-bg {
  width: 100%;
  height: 109px;
  background-image: url(../assets/report/border-bg.png);
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  margin-bottom: 10px;
}

.detailBox-left {
  width: 30%;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 0.8em;
}
.detailBox-left-img {
  width: 56.5px;
  height: 70px;
  margin-bottom: 5px;
}
.detailBox-right {
  width: 70%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
}
.detailBox-right .right-title {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  text-align: left;
  margin-bottom: 20px;
  font-size: 0.7em;
}
.detailBox-right .detailBox-right-nav {
  width: 31%;
  height: 75px;
  background: #fefdfa;
  box-shadow: 0px 10px 15px 1px rgba(220, 223, 238, 0.14);
  border-radius: 9px;
  font-size: 0.7em;
}
.detailBox-right-nav .right-nav-title {
  width: 100%;
  background: #ffbb03;
  padding: 4.5px 0;
  color: #ffffff;
  opacity: 0.7;
  border-radius: 4px 4px 0 0;
  margin-bottom: 15px;
}
.detailBox-right-nav .right-nav-desc {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  /* height: 50px; */
}
.right-title-tip {
  display: block;
  width: 58px;
  padding: 2px 4px;
  margin-right: 5.5px;
  border-radius: 7px;
  background: #ffbb03;
  color: #ffffff;
}
.right-title-text {
  display: flex;
  flex-wrap: wrap;
  width: 70%;
}
.detailBox-right .right-desc {
  display: flex;
  align-items: flex-start;
  text-align: left;
  font-size: 0.75em;
}
.detailBox-right .right-time-icon {
  width: 16.9px;
  height: 16.9px;
}
.detailBox-line {
  z-index: 200;
  position: absolute;
  left: 0;
  bottom: -30px;
  width: 100%;
  height: 49px;
}
.detailBox-line .detailBox-line-img {
  width: 80%;
  height: 100%;
}
.pkBox-bg {
  width: 49%;
  height: 99px;
  background-image: url(../assets/report/border-bg3.png);
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  margin-bottom: 10px;
}
.pkBox-left {
  width: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 0.8em;
}
.pkBox-right {
  width: 44%;
  display: flex;
  flex-direction: column;
  /* align-items: center; */
  text-align: left;
  font-size: 0.8em;
}
.pkBox-right-title {
  /* margin-bottom: 10px; */
}
.pkBox-left-img {
  width: 55px;
  height: 64px;
  margin-bottom: 5px;
}
.bottom-logo {
  width: 80px;
  height: 26px;
  margin: auto;
}
.cnCard {
  position: relative;
  min-height: 30px;
  margin: 10px 17px;
  /* padding-bottom: 10px; */
  background-color: #ffffff;
  border-radius: 20px;
  height: 14.8%;
  /* box-shadow: 0px 0px 17px 1px #5983ff; */
  padding: 27px 13px 0 13px;
}

/* 提示弹窗 */
.fixed-box {
  position: fixed;
  width: 100%;
  height: 200px;
  top: 35%;
  left: 0;
  z-index: 9999;
}

.model-hideBox {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 7%;
}
.model-hide {
  width: 40px;
  height: 40px;
  line-height: 50px;
  border-radius: 50%;
}
.modal_flex {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 7%;
  background: #000000;
  border-radius: 5px;
  opacity: 0.7;
}

.modal-content {
  display: block;
  padding: 8px 5px;
}
.modal-text {
  display: block;
  text-align: left;
  font-size: 12px;
  color: #ffffff;
}

.dayCard {
  position: relative;
  margin: 25px 17px 30px 17px;
  min-height: 157px;
  border-radius: 20px;
  padding-bottom: 5px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background: #fefdfa;
}
.canvasCard {
  background: #ffffff;
  color: #6b6a6b;
  font-family: Source Han Sans CN;
}

.realTop {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  min-height: 33px;
  line-height: 33px;
  word-wrap: break-word;
  word-break: normal;
  text-align: left;
}
.realTop-imgbox {
  position: relative;
  width: 73.5px;
  height: 73.5px;
  margin: 0 10px 0 22px;
}
.realTop-imgbox img {
  position: absolute;
  top: -15px;
  right: 0;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background: #ffffff;
  background: #fefdfa;
  box-shadow: 0px 0px 8px 1px rgba(89, 131, 255, 0.27);
  border-radius: 50%;
  border: 3px solid #ffffff;
}
.realInfo {
  display: flex;
  align-items: center;
  padding: 0 20px;
  background: #f0f1f7;
  border-radius: 15px;
  font-size: 12px;
  margin-top: -16px;
}
.realInfo-name {
  max-width: 82.5px;
  overflow: hidden;
  white-space: nowrap;
  margin-right: 10px;
  font-size: 1.125em;
}
.realInfo-grade {
  overflow: hidden;
  white-space: nowrap;
  font-size: 1.125em;
}
/* 提示弹窗 */
.tip-fixed-box {
  position: fixed;
  width: 100%;
  height: 100px;
  top: 27%;
  left: 0;
  z-index: 9999;
}

.model-hideBox {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 7%;
}
.model-hide {
  width: 40px;
  height: 40px;
  line-height: 50px;
  border-radius: 50%;
}
.modal_flex {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 7%;
  background: #000000;
  border-radius: 5px;
  opacity: 0.7;
}

.modal-content {
  display: block;
  padding: 8px 5px;
}
.modal-text {
  display: block;
  text-align: left;
  font-size: 12px;
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/view/newMonthly.vue